import React, { useState } from 'react';
import Spacing from '../../Spacing';
import { useDocumentTitle } from '../../../hooks/customDocumentTitleHook';
import { can_visit, getPractice, notify } from '../../../helpers';
import { fetchFilterSupports, handelSupport, updateSupportStatus } from '../../../services/Support';
import DataTablePagination from '../../DataTablePagination';
import SupportDataTable from '../../DataTable/SupportDataTable';
import { useEffect } from 'react';
import SupportModal from '../../Modal/SupportModal';


export default function Support({selectedPracticeChange, fetchChangePracticeData}) {
  var location_id = getPractice("location_id");
  var account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }
  const defaultFilter = {
    account_id: account_id,
    location_id: location_id,
    page: 1,
    per_page: 10,
    order_by: [],
  };
  const [filter, setFilter] = useState(defaultFilter);
  const [dataLoading, setDataLoading] = useState(true);
  const [supportList, setSupportList] = useState([]);
  const [paginationCount, setPaginationCount] = useState({
      totalCount: 0,
      totalPages: 0,
    });
  const [activeModal, setActiveModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const defaultDataForm = {
    account_id : account_id,
    location_id : location_id,
    cc_mail : null,
    impact : "",
    feature_type : "",
    subject : "",
    issue : ""
  }
  const [formData, setFormData] = useState(defaultDataForm);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const openActiveModal = () => {
    setActiveModal(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const closeActiveModal = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    setLoading(true);
    if(formData.cc_mail === ""){
      setFormData({ ...formData, cc_mail: null });
      formData.cc_mail = null;
    }

    try {
      const response = await handelSupport(formData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          if(response?.data?.status === "success") {
            notify("success", response?.data?.message);
            setFormData(defaultDataForm);
            await loadFilterdSupports(filter);
            closeActiveModal();
          } else {
            notify("error", response?.data?.message, 0.5);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setLoading(false);
    }
  };

    const handleSupportStatus = async (statusData) => {
      try {
        var response = await updateSupportStatus(statusData);
        if (response?.detail) {
          notify("error", response?.detail);
        } else if(response?.data?.status === 'success'){
          await loadFilterdSupports(filter);
          notify("success", response?.data?.message);
        } else {
          notify("error",  response?.data?.message);
        }
      } catch (error) {
        if (error?.response && error?.response?.data && error?.response?.data?.detail) {
          notify("error", error?.response?.data?.detail);
        }
      }
    };

  const handlePageChange = (newPage) => {
    setFilter({ ...filter, page: newPage });
    setDataLoading(true);
  };


  const handleChangeRowsPerPage = (value) => {
    setFilter({
      ...filter,
      page: 1,
      per_page: value,
    });
    setDataLoading(true);
  };

  const loadFilterdSupports = async (filter) => {
    setFilter(filter);
    let isCanceled = false;

    try {
      const response = await fetchFilterSupports(filter);
      setSupportList(response?.data?.results);
      setPaginationCount({
        totalCount: response.data?.count,
        totalPages: response.data?.total_pages,
      });
    } catch (error) {
      if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
        isCanceled = true;
      } else {
        notify("error", 'Something went wrong');
      }
    } finally {
      if (!isCanceled) {
        setDataLoading(false);
      }
    }
  };

  useEffect(() => {
    setFilter(prevFilter => ({
      ...prevFilter,
      account_id: account_id,
      location_id: location_id
    }));

    setFormData(prevFilter => ({
      ...prevFilter,
      account_id: account_id,
      location_id: location_id
    }));
  }, [account_id, location_id]);


  useEffect(() => {
    loadFilterdSupports(filter);
  }, [filter]);
  

  useDocumentTitle("Support");

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
          Support
        </h2>
        <div className="docpro_page_heading_btns">
          {(can_visit("settings") && can_visit("settings_scheduler_setup")) && (
            <button
              className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
              onClick={openActiveModal}
            >
              <span>Create Support Ticket</span>
            </button>
          )}
        </div>
      </div>
      <Spacing lg="22" sm="22" />
      <div className="docpro_data_table_wrap">
        <div className="docpro_data_table_headings">
        </div>
        <SupportDataTable
          tableData={supportList || []}
          handleSupportStatus={handleSupportStatus}
          reloadData={loadFilterdSupports}
          reloadDataFilter={filter}
          dataLoading={dataLoading}
          setDataLoading={setDataLoading}
        />
        {(supportList.length > 0 && !dataLoading) && (
          <DataTablePagination
            currentPage={filter.page}
            totalPages={paginationCount.totalPages}
            onPageChange={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalRecords={paginationCount.totalCount}
            currentPageData={filter.per_page}
          />
        )}
      </div>
      {activeModal && (
        <SupportModal
          open={activeModal}
          closeDialog={closeActiveModal}
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleFormSubmit}
          loading={loading}
        />
      )}
    </>
  );
}
